const NotFound = () => {
    return (
        <div>
            WHOAAAA!! PAGE NOT FOUND!
        </div>
    )
}

export default NotFound;